import { selector } from "recoil"
import { userListSelector } from "../atoms/users"

export const someHaveOnCameraSelector = selector<boolean>({
  key: "someHaveOnCameraSelector",
  get: ({ get }) => {
    return get(userListSelector).some(user => user.camEnabled)
  }
})

export const someHaveOnMicrophoneSelector = selector<boolean>({
  key: "someHaveOnMicrophoneSelector",
  get: ({ get }) => {
    return get(userListSelector).some(user => user.micEnabled)
  }
})

export const someHaveOnDeviceSelector = selector<boolean>({
  key: "someHaveOnDeviceSelector",
  get: ({ get }) => {
    return get(userListSelector).some(user => {
      return user.camEnabled || user.micEnabled || user.screenShareEnabled
    })
  }
})
